<script setup>
	import { ref, computed, nextTick, onMounted, watch } from "vue";
    import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue';
    import { Navigation, Pagination, Keyboard, A11y } from 'swiper';
    import 'swiper/scss';
    import { DsText, dsUseUniqueId } from '@coloplast/design-system';
    import { useStore } from 'vuex';

    const store = useStore();

    const setActiveHighlight = (payload) => store.commit('setActiveHighlight', payload);
	const activeHighlight = computed(() => store.getters.getActiveHighlight);

	const isFirstInteraction = computed(() => store.getters['getIsFirstInteraction']);
	const setIsFirstInteraction = (payload) => store.commit('setIsFirstInteraction', payload);

    const props = defineProps({
        items: {
            type: Array,
            default: () => [],
        },
    });

	const id = dsUseUniqueId('product-highlight-carousel');

    let swiperInstance;

	watch(activeHighlight, (newValue, oldValue) => {
		if (swiperInstance && newValue != oldValue) {
			swiperInstance.slideTo(activeHighlight.value - 1);
		}
	});

    const settings = ref({
        slidesPerView: props.items.length > 1 ? 1.060 : 1,
        slidesPerGroup: 1,
        spaceBetween: 12,
        sliderOffsetAfter: 24,
        speed: 500,
        mousewheel: true,
        keyboard: true,
        watchOverflow: true,
        pagination: {
            el: `.pagination-${id}`,
            type: 'fraction',
            clickable: false,
        },
        modules: [Navigation, Pagination, Keyboard, A11y],
    });

    const initCarousel = async (swiper) => {
        await nextTick();
        swiperInstance = swiper;
    }

    const onResize = (swiper) => {
		if (swiperInstance) {
			swiperInstance.slideTo(0);
		}
    }

    const changeHighlight = (swiper) => {
        setActiveHighlight(swiper.activeIndex + 1);
    }

	onMounted(() => {
		if (!isFirstInteraction.value) {
			setIsFirstInteraction(true);
		}
		setActiveHighlight(1);
	})
</script>

<template>
    <div class="c-product-highlights-carousel">
        <Swiper
            v-bind="settings"
            @init="initCarousel"
            @resize="onResize"
            @slide-change="changeHighlight"
        >
            <SwiperSlide
                v-for="(item, index) in items"
                :key="`${item.Headline}-${index + 1}`"
            >
                <div class="c-product-highlights-carousel__item">
                    <DsText
						v-if="item.Headline"
                        html-element="h3"
                        text-type="body-md"
                        text-style="bold"
                        class="c-product-highlights-carousel__headline"
                        v-text="item.Headline"
                    >
                    </DsText>
                    <DsText
						v-if="item.Description"
                        text-type="label-sm"
                        class="c-product-highlights-carousel__description"
                        v-text="item.Description"
                    />
                </div>
            </SwiperSlide>
        </Swiper>
    </div>
</template>
